function PageLayout({ title, children }) {
  return (
    <div className="fleks w-full mx-auto px-4 md:w-5/6 lg:w-4/6">
      {children}
    </div>
  );
}

export default PageLayout;
